import { motion } from "framer-motion";
import { Users, Baby, Heart, PersonStanding } from "lucide-react";

const GROUPS = [
  { icon: Heart, title: "Postmenopausale Frauen", text: "Die am besten erforschte Gruppe: Nach der Menopause beschleunigt Östrogenmangel den Knochenabbau. Hier wirken Probiotika und gezielte Ernährung am stärksten.", highlight: true },
  { icon: PersonStanding, title: "Männer & jüngere Erwachsene", text: "Auch Männer verlieren im Alter Knochendichte, und eine knochengesunde Ernährung beugt früh vor. Prävention lohnt sich in jeder Lebensphase – nicht nur nach der Menopause." },
  { icon: Baby, title: "Familien & Peak Bone Mass", text: "Bis zum 18. Lebensjahr wird die maximale Knochenmasse aufgebaut – die Basis fürs ganze Leben. Eltern legen mit hoher Calciumzufuhr den Grundstein für starke Knochen ihrer Kinder." },
];

export default function Audience() {
  return (
    <section id="zielgruppe" className="scroll-mt-24 py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-12">
          <span className="text-xs uppercase tracking-widest font-semibold text-[#C87D55]">Für wen</span>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#1C2D24] flex items-center gap-3">
            <Users className="w-8 h-8 text-[#2D5A27]" /> Knochengesundheit betrifft alle
          </h2>
          <p className="mt-4 text-lg text-[#4A5D52] leading-relaxed">
            Unser Schwerpunkt liegt bei postmenopausalen Frauen – doch starke Knochen sind ein Thema für jedes Alter
            und jedes Geschlecht.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {GROUPS.map((g, i) => (
            <motion.div
              key={g.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className={`rounded-2xl p-7 ring-1 transition-all duration-300 hover:-translate-y-1 ${
                g.highlight ? "bg-[#1E3F20] text-white ring-[#1E3F20]" : "bg-white text-[#1C2D24] ring-[#E2DDD3]"
              }`}
            >
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-5 ${g.highlight ? "bg-white/15" : "bg-[#E2EBE1]"}`}>
                <g.icon className={`w-6 h-6 ${g.highlight ? "text-white" : "text-[#2D5A27]"}`} />
              </div>
              <h3 className="font-display text-xl font-bold mb-2">{g.title}</h3>
              <p className={`text-sm leading-relaxed ${g.highlight ? "text-[#C7D5C4]" : "text-[#4A5D52]"}`}>{g.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
